"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormItem = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const form_1 = tslib_1.__importDefault(require("antd/es/form"));
function FormItem(_a) {
    var { className = '' } = _a, allProps = tslib_1.__rest(_a, ["className"]);
    return React.createElement(form_1.default.Item, Object.assign({}, allProps, { className: `clp-form-item ${className}` }));
}
exports.FormItem = FormItem;
//# sourceMappingURL=FormItem.js.map